import { r as registerInstance, h } from './index-d4808923.js';

const gravityActionImageCss = ".action-image{display:inline-flex;position:relative}.action-image .action-image__img{display:inline-flex}.action-image--fit{height:100%;width:100%}.action-image--fit .action-image__img{height:100%;width:100%}.action-image__overlay{backdrop-filter:blur(10px);background-color:rgba(0, 15, 30, 0.6);height:100%;opacity:0;position:absolute;top:0;width:100%}.action-image__actions{align-items:center;display:flex;height:100%;justify-content:center;opacity:0;position:absolute;top:0;width:100%;z-index:1}.action-image .action-image__overlay,.action-image .action-image__actions{transition:300ms}.action-image:hover .action-image__overlay,.action-image:hover .action-image__actions{opacity:1}";
const GravityActionImageStyle0 = gravityActionImageCss;

const GravityActionImage = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.fallbackSrc = '';
        this.fit = false;
        this.src = '';
    }
    render() {
        return (h("div", { key: '08c5a6ce7cbc8fb181eb7f6683722af5b19eb66d', class: `
          action-image
          ${this.fit ? 'action-image--fit' : ''}
        ` }, h("gravity-image", { key: '06df0c5578187ce8935aa4c7e63e932452a09442', class: "action-image__img", src: this.src, fallbackSrc: this.fallbackSrc, fit: this.fit }), h("div", { key: 'd7ce6c09ecd5778edf98c918dd3b314754e74674', class: "action-image__actions" }, h("slot", { key: '6ae6c5f576bec3f44deddce8596070c025836ceb' })), h("div", { key: '4399345f1463060a9e15a467c65b980e27b15b7e', class: "action-image__overlay" })));
    }
};
GravityActionImage.style = GravityActionImageStyle0;

export { GravityActionImage as gravity_action_image };

//# sourceMappingURL=gravity-action-image.entry.js.map